import React, { useState } from 'react';
import './App.css';
import DomainChecker from './components/DomainChecker';

function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="header">
          <h1>Domain Name Checker</h1>
          <p>Check if your desired domain name is available</p>
        </header>
        <DomainChecker />
      </div>
    </div>
  );
}

export default App;
